import { render, staticRenderFns } from "./thOrderAdd.vue?vue&type=template&id=5880aca3&scoped=true"
import script from "./thOrderAdd.vue?vue&type=script&lang=js"
export * from "./thOrderAdd.vue?vue&type=script&lang=js"
import style0 from "./thOrderAdd.vue?vue&type=style&index=0&id=5880aca3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5880aca3",
  null
  
)

export default component.exports